module.exports = __webpack_public_path__ + "media/images/logo-play-store-f8619da7cb418d97e4e2548ef8c96fc0.png";